export default {
  SET_BATCHES_LIST(state, payload) {
    state.list = (payload.documentos || [])
      .map((batch) => ({ ...batch, selected: false }))
      .reduce((index, option) => ({
        ...index,
        [option.loteId]: option
      }), {});
    state.pagination = {
      items: Number.parseInt(payload.totalElementos, 10),
      pages: Number.parseInt(payload.totalPaginas, 10)
    };
  },
  SET_LIST_LOADING(state, { target, value }) {
    state[target].loading = value;
  },
  SET_LIST(
    state,
    {
      target,
      value
    }
  ) {
    state[target].list = value.map((element) => ({
      id: element.opcionId,
      value: element.valor,
      label: element.descripcion,
      extra: element.extra ? JSON.parse(element.extra) : {}
    }));
  },
  SET_SELECTED_BATCH(state, payload) {
    state.selectedBatch = payload;
  },
  MARK_SELECTED_BATCHES(state, isSelected) {
    state.list = Object.values(state.list).map((element) => ({
      ...element,
      selected: isSelected
    }));
  },
  SET_LOADING(state, payload) {
    state.loading = payload;
  },
  ADD_BATCH(state, payload) {
    console.log('mutazao', payload);
  },
  UPDATE_BATCH(state, batch) {
    state.list[batch.loteId] = batch;
  },
  UPDATE_BATCH_LIST_STATUS(state, { lote }) {
    state.list[lote.loteId].estado = lote.estado;
  },
};
